import { c as _c } from "react/compiler-runtime";
import { Tag01Icon } from '@systemeio/icons';
import { cva, type VariantProps } from 'class-variance-authority';
import { type ComponentPropsWithoutRef } from 'react';
const iconTileVariants = cva('flex shrink-0 items-center justify-center overflow-hidden [&_svg]:block [&_svg]:shrink-0', {
  variants: {
    size: {
      m: 'size-10 rounded-lg [&_svg]:size-[22px]',
      s: 'size-8 rounded-md [&_svg]:size-4'
    },
    tone: {
      white: 'border-border-200 bg-bg-primary text-icon-accent border',
      primary: 'bg-bg-accent text-icon-accent',
      blue: 'bg-palette-blue-bg text-palette-blue-textandicon-secondary',
      purple: 'bg-bg-conditional-light text-icon-conditional-2',
      danger: 'bg-bg-error-light text-icon-error',
      outline: 'border-border-200 text-icon-secondary border',
      lightGreen: 'bg-bg-success-light text-icon-success',
      gray: 'bg-bg-tertiary text-icon-secondary',
      withWord: 'bg-bg-accent text-text-link font-semibold'
    }
  },
  compoundVariants: [{
    size: 'm',
    tone: 'withWord',
    className: 'text-2xl'
  }, {
    size: 's',
    tone: 'purple',
    className: 'bg-palette-purple-bg'
  }, {
    size: 's',
    tone: 'withWord',
    className: 'text-xl'
  }],
  defaultVariants: {
    size: 'm',
    tone: 'white'
  }
});
type IconTileVariantProps = VariantProps<typeof iconTileVariants>;
interface IconTileProps extends ComponentPropsWithoutRef<'span'> {
  size?: IconTileVariantProps['size'];
  tone?: IconTileVariantProps['tone'];
}
function IconTile(t0) {
  const $ = _c(17);
  let children;
  let className;
  let props;
  let size;
  let tone;
  if ($[0] !== t0) {
    ({
      children,
      className,
      size,
      tone,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = size;
    $[5] = tone;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    size = $[4];
    tone = $[5];
  }
  let t1;
  if ($[6] !== className || $[7] !== size || $[8] !== tone) {
    t1 = iconTileVariants({
      className,
      size,
      tone
    });
    $[6] = className;
    $[7] = size;
    $[8] = tone;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== children || $[11] !== tone) {
    t2 = children ?? (tone === "withWord" ? "A" : <Tag01Icon />);
    $[10] = children;
    $[11] = tone;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== props || $[14] !== t1 || $[15] !== t2) {
    t3 = <span className={t1} {...props}>{t2}</span>;
    $[13] = props;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
}
export { IconTile };
export type { IconTileProps };